<template>
  <div>
    <el-card style="min-height: 200px; padding: 20px" v-loading="loading" shadow="never">
      <div v-if="editModel && !errorMsg">
        <el-form
          ref="form"
          :size="$xUISize"
          :model="editModel"
          :rules="editRules"
          @submit.native.prevent
          label-width="auto"
          label-position="top"
        >
          <el-form-item v-if="editModel.storeInfo" label="采购门店" prop="storeGuid">
            {{ editModel.storeInfo.name }}
          </el-form-item>
          <el-form-item
            v-if="editModel.supplierInfo"
            label="供货单位"
            prop="supplierGuid"
          >
            {{ editModel.supplierInfo.name }}
          </el-form-item>
          <el-form-item label="采购清单" prop="itemList">
            <div style="padding: 0px">
              <el-table
                stripe
                v-if="editModel.itemList && editModel.itemList.length > 0"
                :data="editModel.itemList"
                :cell-class-name="delLine"
                :size="$xUISize"
              >
                <el-table-column label="商品信息" min-width="380px">
                  <template slot-scope="scope">
                    <div style="margin-right: 10px">
                      <goods-sku-info :skuInfo="scope.row.skuInfo" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="采购单价" width="180px">
                  <template slot-scope="scope">
                    <el-input
                      type="number"
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.purchasePrice"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="采购单价"
                      style="width: 140px"
                    >
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="采购数量" width="200px">
                  <template slot-scope="scope">
                    <el-input-number
                      :disabled="!!scope.row.isDelete"
                      v-model="scope.row.purchaseCount"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="采购数量"
                      style="width: 140px"
                      :min="0"
                    ></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="建议补货" width="200px">
                  <template slot-scope="scope">
                    <el-input-number
                      :disabled="!!scope.row.isDelete"
                      v-if="scope.row.suggestCount > 0"
                      v-model="scope.row.suggestCount"
                      @change="handleItemGoodsChange(scope.row)"
                      placeholder="建议补货"
                      style="width: 140px"
                      :min="0"
                    ></el-input-number>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120px">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      type="danger"
                      v-if="!scope.row.guid"
                      @click="removeItemClick(scope.row)"
                    >
                      移出
                    </el-button>
                    <el-link
                      v-if="scope.row.guid"
                      :type="scope.row.isDelete ? 'primary' : 'danger'"
                      :underline="false"
                      @click="deleteItemClick(scope.row)"
                    >
                      {{ scope.row.isDelete ? "取消删除" : "标记删除" }}
                    </el-link>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item label="采购信息" prop="purchaseOrderRemark">
            <el-input
              type="textarea"
              v-model="editModel.purchaseOrderRemark"
              :rows="2"
              maxlength="256"
              placeholder="输入采购订单信息"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="快递单号" prop="purchaseTrackingNumber">
            <el-input
              type="textarea"
              v-model="editModel.purchaseTrackingNumber"
              :rows="2"
              maxlength="256"
              placeholder="输入快递单号"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item label="运费金额" prop="freightAmount" key="freightAmount">
            <el-input
              type="number"
              @change="handleItemChange"
              v-model="editModel.freightAmount"
              placeholder="请输入运费金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="实付金额" prop="paymentAmount" key="paymentAmount">
            <el-input
              type="number"
              v-model="editModel.paymentAmount"
              placeholder="请输入实付金额"
            ></el-input>
          </el-form-item>
          <el-form-item label="付款账户" prop="paymentAccount" key="paymentAccount">
            <el-select
              style="width: 100%"
              v-model="editModel.paymentAccount"
              placeholder="请选择付款账户"
            >
              <el-option label="下单未支付" value="下单未支付"> </el-option>
              <el-option label="王文政垫付" value="王文政垫付"> </el-option>
              <el-option label="汲生鑫垫付" value="汲生鑫垫付"> </el-option>
              <el-option label="任天宇垫付" value="任天宇垫付"> </el-option>
              <el-option label="修振垫付" value="修振垫付"> </el-option>
              <el-option label="董明垫付" value="董明垫付"> </el-option>
              <el-option label="公账支付" value="公账支付"> </el-option>
              <el-option label="账期结算" value="账期结算"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算状态" prop="settlementState" key="settlementState">
            <el-select
              style="width: 100%"
              v-model="editModel.settlementState"
              placeholder="请选择结算状态"
            >
              <el-option label="未结算" value="未结算"> </el-option>
              <el-option label="已结算" value="已结算"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="3"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <div style="color: #999999; font-size: 14px; margin-bottom: 10px">
              合计金额:
              <span style="font-size: 18px; color: #f56c6c">
                {{ editModel.totalAmount || 0 }}元
              </span>
            </div>
            <el-button
              type="primary"
              :loading="editSubmit"
              :disabled="
                editSubmit || !editModel.itemList || editModel.itemList.length <= 0
              "
              @click="submitClick"
            >
              提交
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-empty
        v-else-if="!loading && errorMsg"
        :description="errorMsg"
        :image-size="100"
      >
        <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
      </el-empty>
    </el-card>
  </div>
</template>

<script>
import goodsSkuInfo from "../../../../components/business/goodsSkuInfo.vue";
import goodsSkuSelect from "../../../../components/business/goodsSkuSelect.vue";

const defaultModel = {
  itemList: [],
  paymentAmount: "",
  paymentAccount: "下单未支付",
  storeGuidList: "",
  freightAmount: 0,
  totalAmount: 0,
};

export default {
  components: {
    goodsSkuInfo,
    goodsSkuSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        storeGuid: [
          {
            required: true,
            message: "请选择门店或仓库",
            trigger: "change",
          },
        ],
        supplierGuid: [
          {
            required: true,
            message: "供货单位不能为空",
            trigger: "change",
          },
        ],
        itemList: [
          {
            validator: (rule, value, callback) => {
              callback();
            },
            required: true,
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    delLine({ row, column, rowIndex, columnIndex }) {
      if (row.isDelete) return "del_line";
    },
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
      }
    },
    deleteItemClick(item) {
      item.isDelete = item.isDelete ? 0 : 1;
      this.handleItemChange();
    },
    removeItemClick(row) {
      if (!this.editModel.itemList) {
        this.editModel.itemList = [];
      }
      let indexOf = -1;
      this.editModel.itemList.forEach((i, index) => {
        if (row.skuGuid == i.skuGuid) {
          indexOf = index;
        }
      });
      if (indexOf >= 0) {
        this.editModel.itemList.splice(indexOf, 1);
      }
      this.handleItemChange();
    },
    handleItemGoodsChange(item) {
      if (item.purchaseCount < 0) {
        item.purchaseCount = 0;
      }
      if (item.purchasePrice < 0) {
        item.purchasePrice = 0;
      }
      if (item.costPrice < 0) {
        item.costPrice = 0;
      }
      item.totalAmount = Number(
        Number(item.purchasePrice * item.purchaseCount).toFixed(2)
      );
      item.costAmount = Number(Number(item.costPrice * item.purchaseCount).toFixed(2));
      this.handleItemChange();
    },
    handleItemChange() {
      this.editModel.costAmount = Number(this.editModel.freightCost) || 0;
      this.editModel.totalAmount =
        (Number(this.editModel.freightAmount) || 0) -
        (Number(this.editModel.discountAmount) || 0);
      (this.editModel.itemList || []).forEach((item) => {
        if (item.purchaseCount < 0) {
          item.purchaseCount = 0;
        }
        if (item.purchasePrice < 0) {
          item.purchasePrice = 0;
        }
        if (item.costPrice < 0) {
          item.costPrice = 0;
        }
        item.totalAmount = Number(
          Number(item.purchasePrice * item.purchaseCount).toFixed(2)
        );
        item.costAmount = Number(Number(item.costPrice * item.purchaseCount).toFixed(2));
        if (!item.isDelete) {
          this.editModel.totalAmount += Number(item.totalAmount);
          this.editModel.costAmount += Number(item.costAmount);
          this.editModel.totalAmount = Number(
            Number(this.editModel.totalAmount).toFixed(2)
          );
          this.editModel.costAmount = Number(
            Number(this.editModel.costAmount).toFixed(2)
          );
        }
      });
    },
    checkItemList() {
      let flag = true;
      this.editModel.itemList.forEach((i) => {
        if (!i.isDelete && i.goodsCount < 0) {
          flag = false;
        }
      });
      if (!flag) {
        this.error("清单列表数量不能小于0");
      }
      return flag;
    },
    submitClick() {
      if (!this.checkItemList()) {
        return;
      }
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          this.requestApi("biz.warehouse.purchase.info.update", this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("提交成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        }
      });
    },
    handleModel() {
      // nothing
      this.handleItemChange();
    },
    fetchModel() {
      // 编辑
      this.loading = true;
      this.errorMsg = null;
      this.editModel = null;
      if (this.pageParams.guid) {
        return this.requestApi("biz.warehouse.purchase.info.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            return this.requestApi("biz.warehouse.purchase.item.list", {
              purchaseGuid: resp.data.guid,
              storeGuid: resp.data.storeGuid,
            }).then((listResp) => {
              this.editModel = Object.assign({}, defaultModel, resp.data, {
                itemList: (listResp.data.list || []).map((item) => {
                  item.purchaseCount = item.purchaseCount;
                  item.purchasePrice = item.purchasePrice || "";
                  item.suggestCount = item.suggestCount || "";
                  item.costPrice = item.costPrice || "";
                  item.isDelete = 0;
                  return item;
                }),
              });
              this.handleModel();
            });
          })
          .catch((err) => {
            this.errorMsg = (err && err.msg) || (err && err.message) || "数据加载失败";
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.editModel = Object.assign({}, defaultModel);
        this.loading = false;
      }
    },
  },
  created() {
    this.fetchModel();
  },
};
</script>
